<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="addReview">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list class="v-list--booking" v-if="getReviews.length > 0">
            <v-list-item
                :key="review.id"
                @click="editReview(review.id)"
                v-for="review in getReviews"
                :class="`v-list--booking_state f-width ${$route.params.reviewId === review.id ? 'active' : ''}`">
                <v-list-item-title v-text="review.name"/>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.prevent="ReviewChangeState(review.id, review.status)" v-on="on">
                                <v-icon>{{ review.status ? 'remove_red_eye' : 'visibility_off' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>Статус</span>
                    </v-tooltip>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Review from '../../../api/review'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'reviewNavigation',
        components: { Empty },
        methods: {
            addReview () {
                this.$router.push({ name: 'addReview' })
            },
            editReview (id) {
                this.$router.push({
                    name: 'editReview',
                    params: { reviewId: id }
                })
            },
            ReviewChangeState (id, status) {
                Review
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('changeReviewState', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус отзыва изменен успешно',
                            color: 'info'
                        })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        },
        computed: mapGetters([
            'getReviews'
        ]),
    }
</script>
